import { render, staticRenderFns } from "./iconMan.vue?vue&type=template&id=36abeeb4"
import script from "./iconMan.vue?vue&type=script&lang=js"
export * from "./iconMan.vue?vue&type=script&lang=js"
import style0 from "./iconMan.vue?vue&type=style&index=0&id=36abeeb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports